import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import * as theme from "../theme";
import { Button } from "react-bootstrap";
import CancelIcon from "@material-ui/icons/Cancel";
import { Tooltip } from "@material-ui/core";

function TruncatedText({ text, maxLength, type }) {
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(text);
  const [modalWidth, setModalWidth] = useState("60%");
  const [modalHeight, setModalHeight] = useState("50%");
  let ellipsis = text?.length > maxLength ? "..." : ""
  let disableHoverListener = text?.length > maxLength ? false : true
  const toggleModal = () => {
    setShowModal(!showModal);
  };

  useEffect(() => {
    setModalContent(text);
    const lines = text?.split("\n");
    const maxLineLength = Math.max(lines?.map((line) => line.length));

    if (maxLineLength > 50) {
      setModalWidth("60%");
      setModalHeight("70%");
    } else {
      setModalWidth("40%");
      setModalHeight("50%");
    }
  }, [text]);

  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: theme.COLORS.rgba_primary_navyblue,
    },
    content: {
      position: "absolute",
      top: "10%",
      left: "50%",
      transform: "translateX(-50%)",
      width: modalWidth,
      height: modalHeight,
      background: "#eef3f6",
      WebkitOverflowScrolling: "touch",
      border: "8px solid " + theme.COLORS.primary_navyblue,
      borderRadius: "20px",
      padding: 10,
      overflow: "auto",
    },
  };

  const closeButtonStyle = {
    position: "absolute",
    top: "10px",
    right: "10px",
    border: 0,
    cursor: "pointer",
  };

  function formatTextWithStyles(text) {
    const lines = text.split("\n");

    const formattedLines = lines.map((line, index) => {
      const keyValue = line.trim();
      const [key, value] = keyValue.split(":");
      const keyStyle = { fontWeight: "bold" };
      const formattedKey = (
        <span key={index} style={keyStyle}>
          {key.trim()}
        </span>
      );
      const formattedValue =
        value?.length > 50 ? (
          <span key={index + 1} style={{ whiteSpace: "pre-wrap" }}>
            {value}
          </span>
        ) : (
          value
        );

      return (
        <div key={index}>
          {formattedKey} {formattedValue ? ":" : null} {formattedValue}
        </div>
      );
    });

    return formattedLines;
  }
  if(text == null){
    text = "";
  }

  return (
    <div>
      <div>
        <p
          onClick={() => {
            if (text?.length > maxLength && type === "Financing Approved") {
              toggleModal();
            }
          }}
          style={{
            cursor:
              text?.length > maxLength && type === "Financing Approved"
                ? "pointer"
                : "auto",
          }}
        >
          <Tooltip title={text} disableHoverListener={disableHoverListener}> 
            <span>{text?.slice(0, maxLength) + ellipsis }</span> 
          </Tooltip>
        </p>
      </div>
      {showModal && (
        <Modal
          isOpen={showModal}
          onRequestClose={toggleModal}
          contentLabel="Full Text Modal"
          ariaHideApp={false}
          shouldCloseOnEsc={true}
          style={modalStyle}
        >
          <CancelIcon
            fontSize="large"
            style={closeButtonStyle}
            onClick={toggleModal}
          ></CancelIcon>
          <h5 className="bold mt-1 ml-4">Transaction Details - </h5>
          <div className="mt-3 ml-4"> {formatTextWithStyles(modalContent)}</div>
        </Modal>
      )}
    </div>
  );
}

export default TruncatedText;
